import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import _ from 'lodash'
import moment from 'moment'
import accounting from 'accounting'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {Breadcrumb, Segment, Label, Table, Button, Confirm, Modal, Input, List} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import Dls from '../../lib'
import OrderLineView from '../orders/OrderLineView'
import {
    loadOrderById,
    updateOrderStatus,
    holdOrder,
    cancelHold,
    createNote,
    deleteNote
} from '../../actions/order'
import EmailModal from '../utils/EmailModal'
import AddressToolTip from '../orders/parts/AddressToopTips'
import ShipmentSegment from '../orders/parts/ShipmentSegment'
import {api} from '../../api'

class MobileOrderViewPage extends Component {
    constructor() {
        super();
        this.state = {
            routeType: '',
            relationType: '',
            orderType: '',
            deleteConfirm: false,
            cancelBoLoading: false,
            pdfViewer: false,
            base64String: "",
            fieldNames: {
                bill_to: 'Bill To',
                ship_to: 'Ship To',
                warehouse: 'Ship From',
                ship_on: 'Planned Ship Date'
            },
            emailModalShow: false,
            holdReasonModalShow: false,
            onHoldReason: "",
            noteModal: false
        }
    }

    componentDidMount() {
        const {jwt} = this.props;
        const {id} = this.props.match.params;
        const {pathname} = this.props.location;
        const {routeType, relationType, orderType, fieldNames} = this.setPageType(pathname);
        if (!routeType || !relationType || !orderType) {
            this.props.history.replace('/');
            return;
        }

        this.props.loadOrderById(jwt, id, orderType);

        this.setState({
            routeType: routeType,
            relationType: relationType,
            orderType: orderType,
            fieldNames: fieldNames
        });
    }

    onCloseEmailModal = () => {
        this.setState({
            emailModalShow: false
        });
    }

    setPageType(pathname) {
        let routeType = '';
        let relationType = '';
        let orderType = '';
        let fieldNames = {
            bill_to: 'Bill To',
            ship_to: 'Ship To',
            warehouse: 'Ship From',
            ship_on: 'Planned Ship Date'
        }
        if (pathname.includes('customer-orders')) {
            routeType = "customer-orders";
            relationType = "Customer";
            orderType = 'Customer Order';
        }
        if (pathname.includes('vendor-orders')) {
            routeType = "vendor-orders";
            relationType = "Vendor";
            orderType = 'Vendor Order';
            fieldNames = {
                bill_to: 'Vendor Billing',
                ship_to: 'Receive From',
                warehouse: 'Ship To',
                ship_on: 'Planned Ship Date'
            }
        }
        if (pathname.includes('customer-returns')) {
            routeType = "customer-returns"
            relationType = "Customer";
            orderType = 'Customer Return';
            fieldNames = {
                bill_to: 'Customer Billing',
                ship_to: 'Ship From',
                warehouse: 'Return To Warehouse',
                ship_on: 'Planned Ship Date'
            }
        }
        if (pathname.includes('vendor-returns')) {
            routeType = "vendor-returns"
            relationType = "Vendor";
            orderType = 'Vendor Return';
            fieldNames = {
                bill_to: 'Vendor Billing',
                ship_to: 'Ship To',
                warehouse: 'Return From Warehouse',
                ship_on: 'Planned Ship Date'
            }
        }
        return {routeType, relationType, orderType, fieldNames};
    }

    getWarehouseName = () => {
        const {warehouse_id} = this.props.model;
        const {warehouses} = this.props;
        const warehouse = warehouses.filter(i => {
            return i.value === _.toString(warehouse_id);
        });
        if (warehouse.length > 0) {
            return warehouse[0].text;
        }
        return "";
    }

    getTaxName = (type) => {
        const {tax_id} = this.props.model;
        const {taxes} = this.props;
        const tax = taxes.filter(i => {
            return i.value === _.toInteger(tax_id);
        });
        if (tax.length > 0) {
            if (type === 'rate') {
                return tax[0].rate;
            } else {
                return tax[0].text;
            }
        }
        return "";
    }

    getTermName = () => {
        const {term_id} = this.props.model;
        const {terms} = this.props;
        const term = terms.filter(i => {
            return i.value === _.toInteger(term_id);
        });
        if (term.length > 0) {
            return term[0].text;
        }
        return "";
    }

    getAssigneeName = () => {
        const {assigned_to} = this.props.model;
        const {users} = this.props;
        
        const user = users.filter(i => {
            return i.value === _.toString(assigned_to);
        });
        
        if (user.length > 0) {
            return user[0].text;
        }
        return "";
    }

    getCommenterName = (userId) => {
        const {users} = this.props;
        
        const user = users.filter(i => {
            return i.value === _.toString(userId);
        });
        
        if (user.length > 0) {
            return user[0].text;
        }
        return "";
    }
    
    getLineTotal = () => {
        let total = 0;
        _.each(this.props.model.lines_view, line => {
            total = total + (_.toInteger(line.quantity) * _.toNumber(line.price));
        });
        return total;
    }

    getTaxTotal = () => {
        const taxRate = this.getTaxName('rate');
        const lineTotal = this.getLineTotal();
        return taxRate * lineTotal;
    }

    onDeleteConfirmed = () => {
        const {jwt, model} = this.props;
        this.props.updateOrderStatus(jwt, model.id, 'Cancelled').then(res => {
            this.setState({
                deleteConfirm: false
            });
        }).catch(err => {

        })
    }

    onDeleteConfirmCancelled = () => {
        this.setState({
            deleteConfirm: false
        });
    }

    onFinalizedOrderClicked = () => {
        const {jwt, model} = this.props;
        this.props.updateOrderStatus(jwt, model.id, 'Finalized').catch( err => {
            Dls.apiErrorAlert(err);
        });
    }

    onReopenOrderClicked = () => {
        const {jwt, model} = this.props;
        this.props.updateOrderStatus(jwt, model.id, 'Open').catch( err => {
            Dls.apiErrorAlert(err);
        });
    }
    
    _onPrintOptionSelected = () => {
        const params = {
            docType: 'po',
            docId: this.props.model.id
        };
        api.pdf(this.props.jwt, params).then(res => {
            const {data} = res.data;
            this.setState({
                pdfViewer: true,
                base64String: data
            });
        })
    }

    onPdfModalClose = () => {
        this.setState({
            pdfViewer: false
        });
    }

    onPutOnHoldClicked = () => {
        this.setState({
            holdReasonModalShow: true
        });
    }

    onConfirmHold = () => {
        const {onHoldReason} = this.state;
        const {model, jwt} = this.props;
        this.props.holdOrder(jwt, model.id, onHoldReason).then(res => {
            this.setState({
                holdReasonModalShow: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
        })
    }

    onReleaseClicked = () => {
        const {model, jwt} = this.props;
        this.props.cancelHold(jwt, model.id).catch(err => {
            Dls.apiErrorAlert(err);
        })
    }

    openNoteModal = () => {
        this.setState({
            noteModal: true
        });
    }

    onNoteModalClose = () => {
        this.setState({
            noteModal: false
        });
    }

    saveNote = (data) => {
        const {jwt, model, createNote} = this.props;
        createNote(jwt, model.id, data).then(res => {
            this.onNoteModalClose();
        })
    }

    onCancelBoClick = () => {
        const {jwt, model} = this.props;
        this.setState({
            cancelBoLoading: true
        }, () => {
            api.order.cancelBo(jwt, model.id).then(res => {
                this.props.loadOrderById(jwt, model.id, null).then(res => {
                    this.setState({
                        cancelBoLoading: false
                    })
                });
            }).catch(err => {
                console.log(err);
            })
        })
    }

    render() {
        const {model} = this.props;
        const {routeType,relationType,orderType, fieldNames} = this.state;
        return (
            <div>
                {_.isEmpty(model) ? <div></div> : 
                    <div style={{padding: 3, marginTop: 50}}>
                        <div className="row">
                            <div className="col-xs-12">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        <Link
                                            to={`/${routeType}/${Dls.pagination.orders(orderType)}`}
                                        >
                                            {orderType}s
                                        </Link>
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        {model.id ? model.so : `Create New ${orderType}`}
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                                <div style={{float: 'right'}}>
                                    {model.status === 'Open' ? <Label color='teal' size='tiny'>Open</Label> : null}
                                    {model.status === 'Finalized' ? <Label color='blue' size='tiny'>Finalized</Label> : null}
                                    {model.status === 'Pending' ? <Label color='violet' size='tiny'>Pending</Label> : null}
                                    {model.status === 'Finished' ? <Label color='green' size='tiny'>Finished</Label> : null}
                                    {model.status === 'Cancelled' ? <Label color='red' size='tiny'>Cancelled</Label> : null}
                                    {model.status === 'Back Ordered' ? <Label color='orange' size='mini'>Back Ordered</Label> : null}
                                </div>
                            </div>
                        </div>
                        {model.id ? <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-xs-12">
                                <Segment>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div style={{float: 'right'}}>
                                                {model.status === 'Open' ? 
                                                    <Button color='blue' size='mini' onClick={this.onFinalizedOrderClicked}>Finalize</Button> 
                                                : null}
                                            </div>
                                            <div style={{float: 'right'}}>
                                                {model.status === 'Finalized' ? 
                                                    <Button color='teal' size='mini' onClick={this.onReopenOrderClicked}>Re-open</Button> 
                                                : null}
                                            </div>
                                            <div style={{float: 'right'}}>
                                                {model.status === 'Open' ? 
                                                    <Button color='teal' size='mini' as={Link} to={`/mobile/${routeType}/${model.id}/edit`}>Edit</Button> 
                                                : null}
                                            </div>
                                            <div style={{float: 'right'}}>
                                                <Button color='teal' size='mini' onClick={() => {this.setState({emailModalShow: true})}}>Email</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{marginTop: '10px'}}>
                                        <div className="col-xs-6">
                                            {model.woo_id ? <div style={{marginTop: '3px'}}>
                                                    {fieldNames.bill_to} <br />
                                                    <AddressToolTip elementId="billToTip" address={model.woo_billing} />
                                                </div> : 
                                                <div style={{marginTop: '3px'}}>
                                                    {fieldNames.bill_to} <br />
                                                    <AddressToolTip elementId="billToTip" address={model.bill_address} />
                                                </div>
                                            }
                                            {model.woo_id ? <div style={{marginTop: '3px'}}>
                                                    {fieldNames.ship_to} <br />
                                                    <AddressToolTip elementId="billToTip" address={model.woo_shipping} />
                                                </div> : 
                                                <div style={{marginTop: '3px'}}>
                                                    {fieldNames.ship_to} <br />
                                                    <AddressToolTip elementId="shipToTip" address={model.ship_address} />
                                                </div>
                                            }
                                            <div style={{marginTop: '3px'}}>
                                                {fieldNames.warehouse} <br />
                                                <strong>{this.getWarehouseName()}</strong> <br />
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Assigned To: <br />
                                                <strong>{this.getAssigneeName()}</strong>
                                            </div>
                                        </div>
                                        <div className="col-xs-6">
                                            <div style={{marginTop: '3px'}}>
                                                Issue Date: <br />
                                                <strong>{model.issued_at ? model.issued_at : ""}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                {fieldNames.ship_on} <br />
                                                <strong>{model.ship_at ? model.ship_at : ""}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Reference #: <br />
                                                <strong>{model.reference}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                {relationType === 'Customer' ? 'Customer Reference #:' :'Vendor Reference #:'} <br />
                                                <strong>{model.po}<br /></strong>
                                            </div>
                                        </div>
                                        <div className="col-xs-6">
                                            <div style={{marginTop: '3px'}}>
                                                Currency: <br />
                                                <strong>{model.currency}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Tax Code: <br />
                                                <strong>{this.getTaxName('none')}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Payment Term: <br />
                                                <strong>{this.getTermName()}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                {relationType === 'Customer' ? 'Customer Contact:' :'Vendor Contact:'} <br />
                                                <strong>{model.contact ? model.contact.name : null}<br /></strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{marginTop: '10px'}}>
                                        <div className="col-xs-12">
                                        <Table compact>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>
                                                        SKU
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Name
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        UOM
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Quantity
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Stock
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Price
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Fulfilled
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell>
                                                        Total
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {_.isArray(model.lines_view) ? model.lines_view.map(l => {
                                                    return <OrderLineView key={l.id} line={l}
                                                    jwt={this.props.jwt}
                                                    warehouseId={_.toString(model.warehouse_id)} />
                                                }) : null}
                                            </Table.Body>
                                        </Table>
                                        </div>
                                        
                                    </div>
                                    <div className="row" style={{marginTop: '10px'}}>
                                        <div className="col-xs-4">
                                            <div style={{marginTop: '3px'}}>
                                                Total Before Tax: <br />
                                                <strong>{accounting.formatMoney(this.getLineTotal())}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Total Tax ({this.getTaxName('rate')}): <br />
                                                <strong>{accounting.formatMoney(this.getTaxTotal())}<br /></strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Total After Tax: <br />
                                                <strong>{accounting.formatMoney(this.getLineTotal() + this.getTaxTotal())}<br /></strong>
                                            </div>
                                        </div>
                                    </div>
                                </Segment>
                            </div>
                            <div className="col-xs-12">
                                {model.status !== 'Open' && model.status !== 'Cancelled'? <div style={{marginBottom: 10}}>
                                    <Segment>
                                        <div className="row">
                                            <div className="col-xs-6">
                                                <h3>
                                                    Shipments
                                                </h3>
                                            </div>
                                            <div className="col-xs-6">
                                                <div style={{float: 'right'}}>
                                                    {this.props.model.status === 'Finalized' || this.props.model.status === 'Back Ordered' ? <Button color='teal' size='mini' 
                                                        as={Link} to={`/mobile/shipments/create/oid/${model.id}`}
                                                    >
                                                        Create
                                                    </Button>  : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop: '15px'}}>
                                            <div className="col-xs-12">
                                                <ShipmentSegment
                                                    history={this.props.history}
                                                    orderType={model.type}
                                                    warehouses={this.props.warehouses}
                                                    jwt={this.props.jwt}
                                                    shipments={model.shipments} />
                                            </div>
                                        </div>
                                    </Segment>
                                </div> : null}
                            </div>
                        </div> : null}
                        <EmailModal
                            uid={_.uniqueId()}
                            orderType={model.type}
                            id={model.id}
                            doc="Order"
                            to_address={model.contact ? 
                                model.contact.email : 
                                model.relations.email}
                            contact={model.contact ? model.contact.name : 
                                `${model.relations.given_name ? 
                                    model.relations.given_name : ""}${model.relations.family_name ? " "+model.relations.family_name : ""}`}
                            show={this.state.emailModalShow}
                            onModalClose={() => {this.onCloseEmailModal()}}
                            jwt={this.props.jwt}
                        />
                    </div>
                }
            </div>
        )
    }
}

MobileOrderViewPage.propTypes = {
    jwt: PropTypes.string.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
     }).isRequired,
    loadOrderById: PropTypes.func.isRequired,
    updateOrderStatus: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    taxes: PropTypes.array.isRequired,
    terms: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    warehouses: PropTypes.array.isRequired,
    holdOrder: PropTypes.func.isRequired,
    cancelHold: PropTypes.func.isRequired,
    createNote: PropTypes.func.isRequired,
    deleteNote: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.order.model,
        warehouses: state.system.resources.warehouses,
        taxes: state.system.resources.taxes,
        terms: state.system.resources.terms,
        users: state.system.resources.users
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadOrderById,
        updateOrderStatus,
        holdOrder,
        cancelHold,
        createNote,
        deleteNote
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileOrderViewPage)


// WEBPACK FOOTER //
// ./src/components/mobile/MobileOrderView.js